import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Box, Stack, Modal, IconButton, Menu, MenuItem, Typography, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useKeycloak } from '@react-keycloak/web';
import LoadingButton from '@mui/lab/LoadingButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import ImageIcon from '@mui/icons-material/Image';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddDocument from '../../../forms/AddDocument';
import { getFileInfo, updateDocumentStatus, deleteResource, downloadFile } from '../../../../../api/repositorio';
import { StyleModal } from '../../../../modal/styles';
import Input from '../../../../../shared-components/form/Input';
import FilePreview from './filePreview';
import FileStatusModal from './fileStatusModal';

const API_URL = process.env.REACT_APP_API_URL;

const Field = styled(Box)`
  width: 100%;
  margin: 15px 0;
  & label {
    display: inline-block;
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 500;
  }
`;

const Card = styled(Box)`
  background: ${(props) => (!props.darkMode ? '#f2f6fc' : '#121212')};
  /* box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(0, 0, 0, 0.06); */
  border-radius: 6px;
  padding: 20px;
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const NameDocument = styled.p`
  font-size: 12px;
  text-align: center;
  display: block;
  margin-top: 10px;
  font-weight: 600;
  margin-left: 10px;
`;

const ViewSection = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  /* display: flex;
  justify-content: space-evenly;
  align-items: center; */
  padding: 20px;
  margin: 30px 0;
  .section-text {
    margin: 10px;
    display: flex;
    flex-direction: column;
  }
`;

const ViewIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 85px;
  height: 85px;
  border-radius: 50px;
  background: #f2f6fc;
`;

const ContentIcon = styled(Box)`
  text-align: center;
  background: #fff;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

const Index = ({ id, tabId, typeDocument, nameDocument, tabSelectedHandle }) => {
  const { keycloak } = useKeycloak();
  const userRole = keycloak.resourceAccess.puv.roles[0];

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const [openFilePreview, setOpenFilePreview] = useState(false);
  const handleCloseFilePreview = () => setOpenFilePreview(false);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const [fileInfo, setFileInfo] = useState({});

  const [fileModalMessage, setFileModalMessage] = useState('Archivo tiene versiones distintas que dependen de este');
  const [fileModaTitle, setFileModaTitle] = useState('Error al borrar archivo');
  const [openFileModal, setOpenFileModal] = useState(false);
  const [fileStatus, setFileStatus] = useState('');

  const handleOpenFileModal = () => setOpenFileModal(true);
  const handleCloseFileModal = () => setOpenFileModal(false);

  const getDetailsFile = (idFile) => {
    setOpen(true);
    getFileInfo(idFile)
      .then((response) => setFileInfo(response))
      .catch((error) => console.log('error', error));
  };

  console.log('fileInfo', fileInfo);

  const transforDate = () => {
    const options = {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    };
    const date = new Date(fileInfo?.createdAt);
    return date.toLocaleDateString(undefined, options);
  };

  const [loading, setLoading] = useState(false);

  const approveDocument = () => {
    setLoading(true);
    updateDocumentStatus(fileInfo?.id, 2, '')
      .then((response) => {
        setLoading(false);
        getDetailsFile(id);
        console.log('response', response);
      })
      .catch((error) => console.log('error', error));
  };
  

  // const [loadingError, setLoadingError] = useState(false);

  const deleteDocument = () => {
    // setLoadingError(true);
    setLoading(true);
    deleteResource(fileInfo?.id, 1)
      .then((response) => {
        setLoading(false);
        handleClose();
        tabSelectedHandle(tabId);
        if (response.data.code === 'BAD_REQUEST') {
          setFileModalMessage(response.data.mensaje);
          setFileModaTitle('Error al borrar archivo');
          setFileStatus('error');
          handleOpenFileModal();
        }
        console.log("response", response);
      })
      .catch((error) => console.log("error", error));
  };

  const renderIcon = (documentType) => {
    if (documentType) {
      if (documentType === 'pdf') {
        return <PictureAsPdfIcon style={{ height: '15px', fontSize: '6.4rem', color: 'red' }} />;
      }
      if (documentType === 'excel' || documentType === 'xlsx') {
        return <ArticleIcon style={{ height: '15px', fontSize: '6.4rem', color: 'green' }} />;
      }
      if (documentType === 'png' || documentType === 'jpg' || documentType === 'jpeg' || documentType === 'svg') {
        return (
          <ImageIcon
            style={{
              height: '15px',
              fontSize: '6.4rem',
              color: '#7091F5',
            }}
          />
        );
      }
      return <ArticleIcon style={{ height: '42px', fontSize: '6.4rem' }} />;
    }
    return <ArticleIcon style={{ height: '42px', fontSize: '6.4rem' }} />;
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const ITEM_HEIGHT = 48;

  const [openUpdateFile, setOpenUpdateFile] = useState(false);
  const handleCloseUpdateFile = () => setOpenUpdateFile(false);
  const handleopenUpdateFile = () => setOpenUpdateFile(true);

  const [openMessage, setOpenMessage] = useState(false);
  const handleCloseMessage = () => setOpenMessage(false);
  const handleopenMessage = () => setOpenMessage(true);


  const adminOptions = [
    {
      label: 'Aprobar documento',
      action: approveDocument,
    },
    {
      label: 'No aprobar documento',
      action: handleopenMessage,
    },
    {
      label: 'Eliminar documento',
      action: deleteDocument,
    },
  ];

  const userOptions = [
    {
      label: 'Eliminar documento',
      action: deleteDocument,
    },
  ];

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm();

  const [loadingMessage, setLoadingMessage] = useState(false);

  const onSubmit = (dataForm) => {
    setLoadingMessage(true);
    updateDocumentStatus(fileInfo?.id, 3, dataForm.message)
      .then((response) => {
        setLoadingMessage(false);
        getDetailsFile(id);
        handleCloseMessage();
        console.log('response', response);

      })
      .catch((error) => console.log('error', error));
    console.log('dataForm', dataForm);
  };

  const options = userRole === 'Administrador' || userRole === 'NOC' ? adminOptions : userOptions;

  const [fileToDownload, setFileToDownload] = useState();

  const previewFiles = ['jpg', 'jpeg', 'png', 'svg'].includes(fileInfo?.typeDocument);

  useEffect(() => {
    if (fileInfo?.id) {
      setFileToDownload(`${API_URL}/ms-repositorio/file/downloadFile?id=${fileInfo?.id}`);
    }
  }, [fileInfo]);

  return (
    <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', padding: '10px' }} onClick={() => getDetailsFile(id)}>
        <ContentIcon className="file-icon-section">{renderIcon(typeDocument)}</ContentIcon>
        <NameDocument>{nameDocument}</NameDocument>
      </div>
      {/* <Card darkMode={darkMode} elevation={3} key={nameDocument} onClick={() => getDetailsFile(id)}>
      </Card> */}
      {fileInfo && !!Object.keys(fileInfo).length && (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box sx={StyleModal}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <h3>{fileInfo?.nameDocument}</h3>
              </Box>
            </Stack>
            <ViewSection>
              <ViewIcon>{renderIcon(fileInfo?.typeDocument)}</ViewIcon>
              <div className="section-text">
                <Box mb={1}>
                  {/* <strong>Archivo:</strong>{" "} */}
                  <a href={fileToDownload}>
                    <Button size="small" variant="outlined" color="success">
                      Descargar Archivo
                    </Button>
                  </a>
                  {previewFiles && (
                    <Button
                      size="small"
                      variant="outlined"
                      color="info"
                      sx={{ marginLeft: '10px' }}
                      onClick={() => setOpenFilePreview(true)}
                    >
                      Previsualizar Archivo
                    </Button>
                  )}
                  {/* <img src={fileToDownload} alt="hey" /> */}
                </Box>
                <Box mb={1} mt={2}>
                  {(userRole === 'Administrador' || userRole === 'Autor') &&
                    options.map((option, index) => (
                      <Button
                        key={option.label}
                        disabled={!!(option.label === 'Aprobar documento' && fileInfo?.fileStatus?.id === 2)}
                        size="small"
                        variant="outlined"
                        color="inherit"
                        sx={{ marginLeft: index === 0 ? '0px' : '10px' }}
                        onClick={() => {
                          handleCloseMenu();
                          option.action();
                        }}
                      >
                        {option.label}
                      </Button>
                    ))}
                </Box>
              </div>
            </ViewSection>
          </Box>
        </Modal>
      )}
      {/* Modal */}
      <Modal
        open={openUpdateFile}
        onClose={handleCloseUpdateFile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={StyleModal}>
          <IconButton
            aria-label="close"
            onClick={handleCloseUpdateFile}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Actualizar documento
          </Typography>
          <AddDocument
            updateDoc={true}
            folderId={tabId}
            idFile={fileInfo?.id}
            getDetailsFile={getDetailsFile}
            idFileStatus={fileInfo?.fileStatus?.id}
            handleClose={handleCloseUpdateFile}
            tabSelectedHandle={tabSelectedHandle}
          />
        </Box>
      </Modal>
      {/* Modal Message */}
      <Modal open={openMessage} onClose={handleCloseMessage} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={StyleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Motivo el por que no se aprobo el documento
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Field>
              <label>Motivo</label>
              <Input type="text" register={register} errors={errors} keyName="message" placeholder="Escribe el motivo" required />
            </Field>
            <LoadingButton variant="contained" color="success" type="submit" loading={loadingMessage} fullWidth>
              <span>Confirmar</span>
            </LoadingButton>
          </form>
        </Box>
      </Modal>
      {/* Modal for File Operations */}
      <Modal
        open={openFileModal}
        onClose={handleCloseFileModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...StyleModal, textAlign: 'center' }}>
          <IconButton
            aria-label="close"
            onClick={handleCloseFileModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
            {fileModaTitle}
          </Typography>
          <Typography id="modal-modal-title" variant="h6" component="h3">
            {fileModalMessage}
          </Typography>
        </Box>
      </Modal>
      <FileStatusModal
        openFileModal={openFileModal}
        handleCloseFileModal={handleCloseFileModal}
        fileModaTitle={fileModaTitle}
        fileModalMessage={fileModalMessage}
        status={fileStatus}
      />
      <FilePreview url={fileToDownload} fileType={fileInfo.typeDocument} open={openFilePreview} handleClose={handleCloseFilePreview} />
    </Box>
  );
};

export default Index;
